"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sub = exports.Main = exports.Description = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _stitches = require("../../../../stitches.config");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Main = exports.Main = (0, _stitches.styled)('h1', _objectSpread({
  margin: 0,
  color: '$denim500'
}, _stitches.mixins.title1));
var Sub = exports.Sub = (0, _stitches.styled)('h2', _objectSpread({
  margin: 0,
  color: '$narwhal500'
}, _stitches.mixins.title2));
var Description = exports.Description = (0, _stitches.styled)('h2', _objectSpread({
  margin: 0,
  fontWeight: '$1',
  color: '$narwhal500'
}, _stitches.mixins.body));
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');